/* Casilla de suscripción del carrito flotante (ver snippets/kaninor-cart-optin.liquid).

   Al pulsar «Finalizar compra» con la casilla marcada:
   1. Comprueba el email (el de la cuenta si hay sesión; si no, el escrito).
   2. Lo suscribe en Klaviyo (API pública de formularios, lista principal).
   3. Sigue al pago con el email ya puesto.
   Si la casilla no está marcada, el botón funciona como siempre.

   El cajón se vuelve a pintar entero cada vez que cambia el carrito, así que
   todo va por delegación en document y el estado (casilla y email) se guarda
   en sessionStorage para recuperarlo tras cada repintado. */
(function () {
  if (window.kaninorCartOptin) return;
  window.kaninorCartOptin = true;

  var KEY = 'kaninor-cart-optin';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function load() {
    try { return JSON.parse(sessionStorage.getItem(KEY)) || {}; } catch (e) { return {}; }
  }
  function save(state) {
    try { sessionStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
  }

  function box() { return document.querySelector('cart-drawer [data-kaninor-optin]'); }

  function sync() {
    var b = box();
    if (!b) return;
    var state = load();
    var check = b.querySelector('[data-kaninor-optin-check]');
    var wrap = b.querySelector('[data-kaninor-optin-emailwrap]');
    var input = b.querySelector('[data-kaninor-optin-email]');
    if (state.done) { b.hidden = true; return; }
    if (check) check.checked = !!state.checked;
    if (input && state.email && !input.value) input.value = state.email;
    if (wrap) wrap.hidden = !(check && check.checked);
  }

  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-kaninor-optin-check]')) return;
    var state = load();
    state.checked = e.target.checked;
    save(state);
    sync();
    var b = box();
    var input = b && b.querySelector('[data-kaninor-optin-email]');
    if (e.target.checked && input && !input.value) input.focus();
    if (!e.target.checked) showError(false);
  });

  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-kaninor-optin-email]')) return;
    var state = load();
    state.email = e.target.value.trim();
    save(state);
    showError(false);
  });

  function showError(on) {
    var b = box();
    if (!b) return;
    var err = b.querySelector('[data-kaninor-optin-error]');
    var input = b.querySelector('[data-kaninor-optin-email]');
    if (err) err.hidden = !on;
    if (input) {
      if (on) input.setAttribute('aria-invalid', 'true');
      else input.removeAttribute('aria-invalid');
    }
  }

  function subscribe(b, email) {
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Carrito flotante',
          profile: { data: { type: 'profile', attributes: {
            email: email,
            subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
          } } }
        },
        relationships: { list: { data: { type: 'list', id: b.dataset.list } } }
      }
    };
    /* keepalive: la petición sigue aunque la página navegue al pago. */
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(b.dataset.company), {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2025-07-15' },
      body: JSON.stringify(body)
    }).catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#CartDrawer-Checkout');
    if (!btn) return;
    var b = box();
    if (!b || b.hidden) return;
    var check = b.querySelector('[data-kaninor-optin-check]');
    if (!check || !check.checked) return;

    var input = b.querySelector('[data-kaninor-optin-email]');
    var email = (b.dataset.customerEmail || (input && input.value) || '').trim();
    if (!EMAIL_RE.test(email)) {
      e.preventDefault();
      showError(true);
      if (input) input.focus();
      return;
    }

    e.preventDefault();
    btn.setAttribute('aria-busy', 'true');
    var state = load();
    state.done = true;
    save(state);

    var go = function () {
      window.location.href = (window.routes && window.routes.root_url ? window.routes.root_url.replace(/\/$/, '') : '') +
        '/checkout?checkout%5Bemail%5D=' + encodeURIComponent(email);
    };
    /* Se espera la respuesta como mucho 1,5 s para no frenar el pago. */
    Promise.race([subscribe(b, email), new Promise(function (r) { setTimeout(r, 1500); })]).then(go, go);
  });

  /* Repintados del cajón (añadir producto, cambiar cantidad…). */
  var drawer = document.querySelector('cart-drawer');
  if (drawer) new MutationObserver(sync).observe(drawer, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();
